import React from 'react'

function Mtab3() {
  return (
    <div>

<ul className='list-disc list-inside'>

<li>Excess protector</li>
<li>Political violence and terrorism risks.</li>

</ul>
    </div>
  )
}

export default Mtab3